import { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ProductGallery = ({ product, alt }) => {
  const images = useMemo(() => {
    const all = [product.image, ...(product.gallery || [])].filter(Boolean);
    return [...new Set(all)];
  }, [product.image, product.gallery]);
  const [i, setI] = useState(0);
  const current = images[Math.min(i, images.length - 1)] || product.image;
  const go = (d) => setI((x) => (x + d + images.length) % images.length);

  return (
    <div data-testid="product-gallery">
      <div className="group relative rounded-2xl overflow-hidden aspect-square lg:max-w-[540px] flex items-center justify-center" style={{ backgroundColor: product.bgTint }}>
        <img
          key={current}
          src={current}
          alt={alt}
          data-testid="product-gallery-main"
          className="w-full h-full object-contain object-center p-3 sm:p-4"
        />
        {images.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="Photo précédente"
              data-testid="product-gallery-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/85 backdrop-blur-sm text-stone-800 flex items-center justify-center shadow-sm opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300 hover:bg-white"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="Photo suivante"
              data-testid="product-gallery-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/85 backdrop-blur-sm text-stone-800 flex items-center justify-center shadow-sm opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300 hover:bg-white"
            >
              <ChevronRight size={18} />
            </button>
            <span className="absolute bottom-3 right-4 font-mono text-[10px] tracking-[0.2em] text-stone-600" data-testid="product-gallery-counter">
              {Math.min(i, images.length - 1) + 1}/{images.length}
            </span>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div className="mt-3 flex gap-3 lg:max-w-[540px] overflow-x-auto pb-1">
          {images.map((src, idx) => (
            <button
              key={src}
              type="button"
              onClick={() => setI(idx)}
              aria-label={`Photo ${idx + 1}`}
              data-testid={`product-gallery-thumb-${idx}`}
              className={`shrink-0 w-16 h-16 rounded-xl overflow-hidden border transition-colors duration-300 ${idx === i ? "border-[#C85A32]" : "border-stone-200 hover:border-stone-400"}`}
              style={{ backgroundColor: product.bgTint }}
            >
              <img src={src} alt="" className="w-full h-full object-contain p-1.5" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
